import { Link } from 'react-router-dom';
import { getLatestVideos } from '@/mocks/videos';

export default function LatestSection() {
  const latestVideos = getLatestVideos();

  return (
    <section className="py-14 md:py-20 bg-background-50" data-product-shop>
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新上线
            </h2>
            <p className="text-foreground-500 mt-2 text-sm md:text-base">
              每日更新，精彩不断
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {latestVideos.map(video => (
            <Link
              key={video.id}
              to={`/video/${video.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-video bg-background-200">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  title={`${video.title} - 玖玖视频`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-play-fill text-2xl"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 bg-black/75 text-background-50 text-xs px-2 py-0.5 rounded font-medium">
                  {video.duration}
                </div>
                {video.isNew && (
                  <div className="absolute top-2 left-2">
                    <span className="bg-accent-500/90 text-background-50 text-xs px-2 py-0.5 rounded font-medium">
                      最新
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                {video.title}
              </h3>
              <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <div className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-eye-line"></i>
                  </div>
                  {video.views >= 10000 ? `${(video.views / 10000).toFixed(1)}万` : video.views}
                </span>
                <span className="bg-secondary-100 text-secondary-700 text-xs px-2 py-0.5 rounded whitespace-nowrap">
                  {video.category}
                </span>
                <span className="text-foreground-400">{video.date}</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 px-6 py-2.5 rounded-full border border-primary-300 text-primary-600 hover:bg-primary-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部最新视频
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}